import React from 'react'
import { Box, Fade } from '@mui/material'
import { keyframes } from '@mui/system'
import { useScreenSaver } from '../contexts/ScreenSaverContext'
import agentFlowLogo from '../assets/AgentFlowIZZI.svg'
import backgroundImage from '../assets/izzi-background.jpg'

// Define fade animation
const fadeInOut = keyframes`
  0% {
    opacity: 0.3;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0.3;
  }
`

const ScreenSaver = () => {
  const { isScreenSaverActive, deactivateScreenSaver } = useScreenSaver()

  const handleClick = (e) => {
    e.preventDefault()
    e.stopPropagation()
    deactivateScreenSaver()
  }

  if (!isScreenSaverActive) {
    return null
  }

  return (
    <Fade in={isScreenSaverActive} timeout={500}>
      <Box
        sx={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          zIndex: 9999,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundImage: `url(${backgroundImage})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          cursor: 'pointer',
          '&::before': {
            content: '""',
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.4)', // Match login page overlay
            zIndex: 1,
          },
        }}
        onClick={handleClick}
        onMouseMove={deactivateScreenSaver}
        onKeyDown={deactivateScreenSaver}
        tabIndex={0} // Make it focusable for keyboard events
      >
        <Box
          sx={{
            position: 'relative',
            zIndex: 2,
            textAlign: 'center',
          }}
        >
          <img
            src={agentFlowLogo}
            alt="AgentFlow"
            style={{
              maxWidth: '600px',
              width: '80vw',
              height: 'auto',
              filter: 'brightness(0.9)',
              animation: `${fadeInOut} 3s ease-in-out infinite`,
              dropShadow: '0 0 30px rgba(176, 176, 176, 0.4)',
            }}
          />

          {/* Subtle hint text */}
          <Box
            sx={{
              mt: 6,
              color: 'rgba(255, 255, 255, 0.6)',
              fontSize: '1.1rem',
              fontWeight: 300,
              letterSpacing: '0.1em',
              animation: `${fadeInOut} 4s ease-in-out infinite`,
              animationDelay: '1s',
            }}
          >
            Move mouse or press any key to continue
          </Box>
        </Box>
      </Box>
    </Fade>
  )
}

export default ScreenSaver